export const appConfig = {
  baseApiUrl: process.env.REACT_APP_API_BASE_ULR || "http://localhost:8080",
};
